<template>
  <div class="cancel-progress-container">
    <div class="cancel-header-container flex justify-between items-center">
      <div class="step-item active-color flex flex-col items-center justify-center">
        <img src="https://static.bakmigm.co.id/menu-pc/oms/refund-start.svg" />
        <span class="step-title">{{ $t("result.cancel.refund.orderCancel.title") }}</span>
      </div>
      <div class="step-item active-color light flex flex-col items-center justify-center">
        <img src="https://static.bakmigm.co.id/menu-pc/oms/refund-submit.svg" />
        <span class="step-title">{{ $t("result.cancel.refund.refundSubmit.title") }}</span>
      </div>
      <div
        v-if="orderRefundData.refundHeader.statusId === 'PENDING'"
        class="step-item light-color flex flex-col items-center justify-center"
      >
        <img src="https://static.bakmigm.co.id/menu-pc/oms/refund-pending.svg" />
        <span class="step-title">{{ $t("result.cancel.refund.refundPending.title") }}</span>
      </div>
      <div
        v-if="orderRefundData.refundHeader.statusId === 'FAILED'"
        class="step-item active-color flex flex-col items-center justify-center"
      >
        <img src="https://static.bakmigm.co.id/menu-pc/oms/refund-failure.svg" />
        <span class="step-title">{{ $t("result.cancel.refund.refundFailure.title") }}</span>
      </div>
      <div
        v-if="orderRefundData.refundHeader.statusId === 'SUCCEEDED'"
        class="step-item active-color flex flex-col items-center justify-center"
      >
        <img src="https://static.bakmigm.co.id/menu-pc/oms/refund-success.svg" />
        <span class="step-title">{{ $t("result.cancel.refund.refundSuccess.title") }}</span>
      </div>
    </div>
    <div class="cancel-footer-container">
      <span class="submit-text">
        {{ $t("result.cancel.refund.refundDesc") }} {{ formatTime(orderRefundData.refundHeader.submitDateTime.dbStamp) }}
      </span>
      <button class="track-btn" @click="onClickTrackBtn">
        {{ $t("result.cancel.refund.trackBtn") }}
      </button>
    </div>
    <CancelReasonDialog :show-dialog="showDialog" @close="onCloseDialog" />
  </div>

</template>

<script setup>
import { ref, defineEmits, computed, inject } from 'vue';
import dayjs from 'dayjs';
import CancelReasonDialog from './CancelReasonDialog.vue'

const orderData = inject('orderData');

const showDialog = ref(false);
const details = computed(() => orderData.value?.orderDetail || {});

const orderRefundData = computed(() => {
  if (Array.isArray(details.value.payments) && details.value.payments.length > 0) {
    return details.value.payments[0].orderRefund;
  }
  return {
    refundActive: false,
    refundHeader: {
      submitDateTime: 0
    }
  }
})

const refundResult = computed(() => {
  const finalResult = orderRefundData.value.refundHistory.find((item) => item.statusId ===
    orderRefundData.value.refundHeader.statusId)
  return finalResult;
})

const isCancelOrder = computed(() => {
  if (Array.isArray(details.value.payments) && details.value.payments.length > 0) {
    return details.value.payments[0].orderRefund?.refundActive === true;
  }
  return false;
});
const formatTime = ($timestamp) => {
  if (!$timestamp) return '';
  return dayjs($timestamp).format('DD MMMM YYYY HH:mm A')
}

const onClickTrackBtn = () => {
  showDialog.value = true;
}
const onCloseDialog = () => {
  showDialog.value = false;
}
</script>

<style lang="scss" scoped>
.cancel-progress-container {
  width: 100%;
  background: var(--Grey-100, #F3F4F6);
  border-radius: 8px;
  .cancel-header-container {
    padding: 16px;
    border-bottom: 1px solid #BDBDBD;
    .step-item {
      display: flex;
      width: 70px;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      position: relative;
      &:first-child {
        &::after {
          width: 0;
        }
      }
      &::after {
        content: "";
        width: 20px;
        height: 1px;
        background-color: #232323;
        position: absolute;
        left: -36px;
        top: 36px;

      }
    }
    .light-color {
      color: #BDBDBD;
    }
    .active-color {
      color: #232323;
    }

    .step-title {
      text-align: center;

      /* Inter/Bold/M */
      font-family: Montserrat;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
  .cancel-footer-container {
    padding: 16px;
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    .submit-text {
      color: #232323;
      font-family: Montserrat;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px; /* 150% */
      letter-spacing: -0.36px;
      text-align: left;
    }

    .track-btn {
      color: #232323;
      /* Inter/Bold/M */
      font-family: Montserrat;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      padding: 10px 24px;
      border-radius: 100px;
      background-color: #fff;
      border: 1px solid #EEE;
      background: var(--horego-brand-white, #FFF);
    }
  }
}
.flex {
  display: flex;
}
.flex-col {
  flex-direction: column;
}
.justify-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
</style>
